import { Checkbox } from '@mui/material';
import { styled } from '@mui/material/styles';

import CheckmarkIcon from 'app/assets/icons/checkmark-3.svg?react';

const CheckboxIcon = styled('span')(({ theme }) => ({
  borderRadius: 2,
  width: 20,
  height: 20,
  border: '2px solid #C2C5CD',
  backgroundColor: 'transparent',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: '#ebf1f5',
  },
  'input:disabled ~ &': {
    border: '1px solid #E0E2E8',
    backgroundColor: '#F1F2F6',
  },
}));

const CheckedCheckboxIcon = styled(CheckboxIcon)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: 'none',
  backgroundColor: '#327D5D',
  color: 'white',
  'input:hover ~ &': {
    backgroundColor: '#327D5D',
  },
  'input:disabled ~ &': {
    backgroundColor: '#E0E2E8',
    color: '#696D7F',
  },
});

const IndeterminateCheckboxIcon = styled(CheckboxIcon)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: 'none',
  backgroundColor: '#327D5D',
  color: 'white',
  '&::before': {
    content: '""',
    width: 10,
    height: 2,
    backgroundColor: 'white',
    borderRadius: 1,
  },
  'input:hover ~ &': {
    backgroundColor: '#327D5D',
  },
  'input:disabled ~ &': {
    backgroundColor: '#E0E2E8',
    color: '#696D7F',
  },
});

function CustomCheckbox(props) {
  return (
    <Checkbox
      sx={{
        '&:hover': { bgcolor: 'transparent' },
        padding: 0,
      }}
      disableRipple
      checkedIcon={
        <CheckedCheckboxIcon>
          <CheckmarkIcon />
        </CheckedCheckboxIcon>
      }
      icon={<CheckboxIcon />}
      indeterminateIcon={<IndeterminateCheckboxIcon />}
      {...props}
    />
  );
}

export default function HealtheraCheckbox({ onChange, ...props }) {
  return <CustomCheckbox onChange={(e) => onChange && onChange(e.target.checked)} {...props} />;
}
